{
  "home-page": {
    "meta": {
      "title": "Beauty Booking",
      "description": "Online-Termine, Rabatt für Nägel, Angebote für Nägel, Augenbrauen-Rabatt, Augenbrauen-Angebote,Wimpern-Rabatt, Wimpern-Angebote, PMU-Rabatt, PMU-Angebote"
    },
    "text": {
      "book-appointment-again": "Buchen Sie neue Termine in den Salons, die Sie besucht haben"
    }
  }
}
